import React from 'react'
import {Button, Card, Col, Row} from "antd";
import {GroupOutlined, MailOutlined, OrderedListOutlined} from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {DEFAULT_GUTTER} from "../../constants";

export default function MarketplaceHeader() {
    const navigate = useNavigate();
    return (
        <>

            <Card style={{background: 'white'}}>
                <Row gutter={DEFAULT_GUTTER}>
                    <Col md={20} xs={24}>
                        <h1>🛒 Lokaal lekkers uit jouw buurt – vers van het land</h1>
                        <h2>Ontdek groente, fruit, eieren en meer van tuinders en makers bij jou in de buurt. Rechtstreeks van de bron – zonder omweg, zonder onzin.</h2>


                        <Button type={"primary"} onClick={() => {
                            navigate('/subscribe')
                        }}>
                            <MailOutlined/> Inschrijven voor Oogst Alerts
                        </Button>
                    </Col>
                    <Col md={4} xs={24}>
                        <img src={"/static/img/wortels.png"} style={{maxWidth: '100%', borderRadius: '10px'}}/>
                    </Col>
                </Row>
            </Card>
            <Row className={"mar-b-1 mar-t-1"}>
                <Col span={24} className={"text-right"}>
                    <Button className={"mar-r-1"} onClick={() => {
                        navigate('/markt/kaart')
                    }}>
                        <GroupOutlined/> Kaart
                    </Button>
                    <Button className={"mar-r-1"} onClick={() => {
                        navigate('/markt')
                    }}>
                        <OrderedListOutlined/> Lijst
                    </Button>
                </Col>
            </Row>
        </>
    )
}